import React from 'react'
import ProjectDetail from './ProjectDetail'
// Importation d'une image
import SkiPic from '../imgs/skiWebsite.jpg'

function Ski() {
  return (
    <ProjectDetail
      title="Ski Website"
      tech={['HTML', 'CSS']}
      image={SkiPic}
      imageAlt="Ski website home page"
      github="https://github.com/nicocarr04/website-ski-exemple"
      path="/wski"
      description="Ski website by Nicolas Carriere: an HTML and CSS site for ski enthusiasts with lift tickets, equipment rentals and lessons added to a reservation cart."
    >
      <p>
        I developed a ski website that aims to provide a comprehensive platform for ski enthusiasts. The website offers a range of features designed to enhance your skiing experience. While still a work in progress, one notable feature is the ability to add reservations to your cart. Whether you're looking for lift tickets, equipment rentals, or ski lessons, the intuitive interface allows you to easily select and add these items to your cart.
      </p>
    </ProjectDetail>
  )
}

export default Ski
